export default __webpack_public_path__ + "static/media/profile.03cfc3f8.png";